import { Box, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useIsDesktop } from 'Hooks';

export const BubbleData = () => {
  const isDesktop = useIsDesktop();
  return (
    <Box
      zIndex={1}
      position='absolute'
      top={0}
      left={'-358px'}
      sx={{
        transform: isDesktop ? 'translate(-25%,-110%)' : 'translate(-5%,-110%)',
      }}
      bgcolor='white'
      border='1px solid'
      borderColor={'primary.shade_200'}
      borderRadius='8px'
      boxShadow='0px 8px 24px 0px rgba(8, 30, 84, 0.15)'
      padding='20px 24px 20px 16px'
      width={'519px'}
    >
      <Typography variant={'body3'} tabIndex={0}>
        {
          Dictionary[DICTIONARY.PersonalDetails].disabilityInformation
            .bubbleInfo
        }
      </Typography>
      <Box
        position='absolute'
        bottom={0}
        left={isDesktop ? '94%' : '5%'}
        sx={{
          transform: 'translate(0,100%)',
          '&::before': {
            content: '""',
            width: 0,
            height: 0,
            borderLeft: '10px solid transparent',
            borderRight: '10px solid transparent',
            borderTop: '10px solid white',
            position: 'absolute',
            top: 0,
            right: 0,
            transform: 'translate(50%,-120%)',
            zIndex: 1,
          },
        }}
        width={0}
        height={0}
        borderLeft='10px solid transparent'
        borderRight='10px solid transparent'
        borderTop='10px solid #B7CCFF'
      ></Box>
    </Box>
  );
};
